import { HubspotFormEmbed } from 'src/components/atoms/HubspotFormEmbed'
import TypographyRebrand, {
  TypographyRebrandProps
} from 'src/components/atoms/TypographyRebrand/TypographyRebrand'
import { HubspotFormRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'

type TextColor = NonNullable<TypographyRebrandProps['color']>

type BackgroundStyle =
  | { kind: 'color'; className: string; textColor: TextColor }
  | {
      kind: 'pattern'
      src: string
      overlayClassName?: string
      textColor: TextColor
    }

const BACKGROUND_STYLES: Record<
  NonNullable<HubspotFormRebrandResult['color']>,
  BackgroundStyle
> = {
  limeBright: {
    kind: 'pattern',
    src: '/img/hero/patterns/patternGreenMarble.png',
    overlayClassName: 'bg-limeBright/50',
    textColor: 'forestDeep'
  },
  lavenderBright: {
    kind: 'pattern',
    src: '/img/hero/patterns/patternLavenderSoft.png',
    overlayClassName: 'bg-lavenderBright/50',
    textColor: 'forestDeep'
  },
  patternDarkForest: {
    kind: 'pattern',
    src: '/img/hero/patterns/patternDarkForest.png',
    textColor: 'linen'
  },
  patternPurpleForest: {
    kind: 'pattern',
    src: '/img/hero/patterns/patternPurpleForest.png',
    textColor: 'forestDeep'
  }
}

export const HubspotFormRebrand = ({
  heading,
  subheading,
  formId,
  color = 'limeBright'
}: HubspotFormRebrandResult) => {
  const background = BACKGROUND_STYLES[color]
  const { textColor } = background

  return (
    <section
      className={`relative w-full overflow-hidden ${
        background.kind === 'color' ? background.className : ''
      }`}
    >
      {background.kind === 'pattern' && (
        <>
          <div
            aria-hidden
            className='absolute inset-0 pointer-events-none bg-cover bg-center'
            style={{ backgroundImage: `url(${background.src})` }}
          />
          {background.overlayClassName && (
            <div
              aria-hidden
              className={`absolute inset-0 pointer-events-none ${background.overlayClassName}`}
            />
          )}
        </>
      )}
      <div className='container relative mx-auto flex flex-col gap-8 px-4 py-16 lg:flex-row lg:items-start lg:gap-12 lg:px-20 lg:py-20'>
        <div className='flex flex-col gap-2.5 px-10 lg:mt-10 lg:w-1/2 lg:px-0'>
          {heading && (
            <TypographyRebrand variant='h4' color={textColor}>
              {heading}
            </TypographyRebrand>
          )}
          {subheading && (
            <TypographyRebrand variant='introduction' color={textColor}>
              {subheading}
            </TypographyRebrand>
          )}
        </div>
        <div className='-mt-10 w-full lg:mt-2 lg:w-1/2'>
          <HubspotFormEmbed formId={formId} />
        </div>
      </div>
    </section>
  )
}

export default HubspotFormRebrand
